import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 flex flex-col items-center text-center gap-6">
          <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center">
            <XCircle className="h-8 w-8 text-muted-foreground" />
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-semibold">Payment Cancelled</h1>
            <p className="text-sm text-muted-foreground">
              Your payment was cancelled and you have not been charged.
              You can try again whenever you are ready.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <Button variant="outline" className="flex-1 gap-2" asChild>
              <Link to="/dashboard">
                <ArrowLeft className="h-4 w-4" />
                Dashboard
              </Link>
            </Button>
            <Button className="flex-1" asChild>
              <Link to="/subscription/pricing">
                View Plans
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
